import { PropertyType } from '../../../common';

export const mapToFormData = (data: PropertyType): PropertyType => {
	const formData = new FormData();
	const keys = Object.keys(data);

	keys.forEach((key) => {
		if (key !== 'filters') {
			formData.append(key, data[key]);
		} else {
			formData.append(key, JSON.stringify(data[key]));
		}
	});
	return formData;
};

export const mapEntityToApi = (data: PropertyType): PropertyType => {
	const { gameProviderForm, token } = data;
	const apiData: PropertyType = {
		sid: token,
	};

	if (gameProviderForm.game_provider_name) apiData.game_provider_name = gameProviderForm.game_provider_name;
	if (gameProviderForm.game_provider_id) apiData.game_provider_id = gameProviderForm.game_provider_id;
	if (gameProviderForm.provider_url_live_desktop)
		apiData.provider_url_live_desktop = gameProviderForm.provider_url_live_desktop;
	if (gameProviderForm.provider_url_test_desktop)
		apiData.provider_url_test_desktop = gameProviderForm.provider_url_test_desktop;
	if (gameProviderForm.provider_url_live_mobile)
		apiData.provider_url_live_mobile = gameProviderForm.provider_url_live_mobile;
	if (gameProviderForm.provider_url_test_mobile)
		apiData.provider_url_test_mobile = gameProviderForm.provider_url_test_mobile;
	if (gameProviderForm.history_url_live) apiData.history_url_live = gameProviderForm.history_url_live;
	if (gameProviderForm.history_url_test) apiData.history_url_test = gameProviderForm.history_url_test;
	apiData.active = gameProviderForm.active ? '1' : '0';

	return apiData;
};
